import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  kycActivityList: { loading: false, data: null, error: null },
  AgreementActivityList: { loading: false, data: null, error: null },
  changeStatusForKycActivity: { loading: false, data: null, error: null },
  changeStatusForAggrementActivity: { loading: false, data: null, error: null },
  addCommentsForKycActivity: { loading: false, data: null, error: null },
  kycAgreementList: { loading: false, data: null, error: null },
};

export const KYCStatusActivitySlice = createSlice({
  name: "kycStatus",
  initialState,
  reducers: {
    fetchkycActivityListRequest: (state, action) => {
      state.kycActivityList.loading = true;
      state.kycActivityList.error = null;
    },
    fetchAgreementActivityListRequest:(state,action)=>{
      state.AgreementActivityList.loading= true;
      state.AgreementActivityList.error = null;

    },
    fetchAgreementActivityListSuccess:(state,action)=>{
      state.AgreementActivityList.data = action.payload;
      state.AgreementActivityList.loading= false;
      state.AgreementActivityList.error = null;
    },
    fetchAgreementActivityListFailure:(state,action)=>{
      state.AgreementActivityList.data = null;
      state.AgreementActivityList.loading= false;
      state.AgreementActivityList.error = action.payload;
    },
    fetchkycActivityListSuccess: (state, action) => {
      state.kycActivityList.data = action.payload;
      state.kycActivityList.loading = false;
      state.kycActivityList.error = null;
    },
    fetchkycActivityListFailure: (state, action) => {
      state.kycActivityList.data = null;
      state.kycActivityList.loading = false;
      state.kycActivityList.error = action.payload;
    },
    kycActivityChangeStatusRequest: (state, action) => {
      state.changeStatusForKycActivity.loading = true;
      state.changeStatusForKycActivity.error = null;
    },
    AggrementActivityChangeStatusRequest:(state,actoin) =>{
      state.changeStatusForAggrementActivity.loading= true;
      state.changeStatusForAggrementActivity.error = null;
    },
    kycActivityChangeStatusSuccess: (state, action) => {
      state.changeStatusForKycActivity.data = action.payload;
      state.changeStatusForKycActivity.loading = false;
      state.changeStatusForKycActivity.error = null;
    },
    AggrementActivityChangeStatusSuccess:(state,action)=>{
      state.changeStatusForAggrementActivity.data = action.payload;
      state.changeStatusForAggrementActivity.loading= false;
      state.changeStatusForAggrementActivity.error = null;
   },
  AggrementActivityChangeStatusFailure :(state,action)=>{
   state.changeStatusForAggrementActivity.data = null;
   state.changeStatusForAggrementActivity.loading = false;
   state.changeStatusForAggrementActivity.error = action.payload;
   },
  AggrementActivityChangeStatusReset :(state,action)=>{
   state.changeStatusForAggrementActivity.data = null;
   state.changeStatusForAggrementActivity.loading = false;
   state.changeStatusForAggrementActivity.error = action.payload;
   },
    kycActivityChangeStatusFailure: (state, action) => {
      state.changeStatusForKycActivity.data = null;
      state.changeStatusForKycActivity.loading = false;
      state.changeStatusForKycActivity.error = action.payload;
    },
    addCommentsForkycActivityRequest: (state, action) => {
      state.addCommentsForKycActivity.loading = true;
      state.addCommentsForKycActivity.error = null;
    },
    addCommentsForkycActivitySuccess: (state, action) => {
      state.addCommentsForKycActivity.data = action.payload;
      state.addCommentsForKycActivity.loading = false;
      state.addCommentsForKycActivity.error = null;
    },
    addCommentsForkycActivityFailure: (state, action) => {
      state.addCommentsForKycActivity.data = null;
      state.addCommentsForKycActivity.loading = false;
      state.addCommentsForKycActivity.error = action.payload;
    },
    resetKYCStatus: (data, action) => {
      data.changeStatusForKycActivity.data = null;
      data.changeStatusForKycActivity.error = null;
      data.changeStatusForKycActivity.loading = false;

      data.addCommentsForKycActivity.data = null;
      data.addCommentsForKycActivity.error = null;
      data.addCommentsForKycActivity.loading = false;
    },
    fetchKycAgreementListRequest: (state, action) => {
      state.kycAgreementList.loading = true;
      state.kycAgreementList.error = null;
    },
    fetchKycAgreementListSuccess: (state, action) => {
      state.kycAgreementList.data = action.payload;
      state.kycAgreementList.loading = false;
      state.kycAgreementList.error = null;
    },
    fetchKycAgreementListFaliure: (state, action) => {
      state.kycAgreementList.data = null;
      state.kycAgreementList.loading = false;
      state.kycAgreementList.error = action.payload;
    },
  },
});

export const {
  fetchkycActivityListRequest,
  fetchkycActivityListSuccess,
  fetchkycActivityListFailure,
  kycActivityChangeStatusRequest,
  kycActivityChangeStatusSuccess,
  AggrementActivityChangeStatusRequest,
  AggrementActivityChangeStatusFailure,
  AggrementActivityChangeStatusReset,
  AggrementActivityChangeStatusSuccess,
  fetchAgreementActivityListFailure,
  fetchAgreementActivityListSuccess,
  fetchAgreementActivityListRequest,
  kycActivityChangeStatusFailure,
  addCommentsForkycActivityRequest,
  addCommentsForkycActivitySuccess,
  addCommentsForkycActivityFailure,
  resetKYCStatus,
  fetchKycAgreementListRequest,
  fetchKycAgreementListSuccess,
  fetchKycAgreementListFaliure,
} = KYCStatusActivitySlice.actions;

export const getKYCStatusSliceListState = (state) =>
  state.kycStatus?.kycActivityList;
  export const getAgreementStatusSliceListState = (state) =>
  state.kycStatus?.kycActivityList;
export const getChangeKYCStatusState = (state) =>
  state.kycStatus?.changeStatusForKycActivity;
export const getAgreementListState = (state)=>
 state.kycStatus?.changeStatusForAggrementActivity;
export const getKycAgreementListState = (state) =>
  state.kycStatus?.kycAgreementList;

export default KYCStatusActivitySlice.reducer;
